// Iter52.96 · Fechas de la línea explicativa del traspaso. Aritmética pura de
// año/mes/día: nunca `toISOString()`, que pasa a UTC y en España (UTC+1/+2)
// devuelve el día anterior.
const ymd = (y, m, d) => `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

const diasDelMes = (y, m) => new Date(Date.UTC(y, m, 0)).getUTCDate();

// 'YYYY-MM' del mes siguiente al de `hoy` (componentes locales, sin UTC).
export const mesSiguienteISO = (hoy = new Date()) => {
  const y = hoy.getFullYear(), m = hoy.getMonth() + 2;
  return m > 12 ? `${y + 1}-01` : `${y}-${String(m).padStart(2, '0')}`;
};

// Día 1 del mes elegido: inicio del destino.
export const inicioDestino = (mes) => (mes ? `${mes}-01` : '');

// Día anterior al 1 del mes elegido: fin de cobro del origen.
export const finCobroOrigen = (mes) => {
  if (!mes) return '';
  const [y, m] = mes.split('-').map(Number);
  if (!y || !m) return '';
  const py = m === 1 ? y - 1 : y, pm = m === 1 ? 12 : m - 1;
  return ymd(py, pm, diasDelMes(py, pm));
};

// Día 1 del mes (mes elegido + N meses de cortesía): inicio de cobro.
export const inicioCobro = (mes, n) => {
  if (!mes || n === '' || n === null || n === undefined) return '';
  const [y, m] = mes.split('-').map(Number);
  const k = Number(n);
  if (!y || !m || Number.isNaN(k)) return '';
  const t = (m - 1) + k;
  return ymd(y + Math.floor(t / 12), (((t % 12) + 12) % 12) + 1, 1);
};
